const add = (a, b) => a + b;

export const proteinConstant = 4;
export const carbohydratesConstant = 4;
export const fatConstant = 9;
export const roughageConstant = 2;
export const sugarConstant = 4;
export const saturatedFattyAcidsConstant = 9;
export const saltConstant = 0;

export const getTotalMenuPlanners = (property, calorific, menuPlanners) =>
  menuPlanners
    .map(row => {
      const mealTypeId = row.mealType.split('/').pop();
      const key = `${calorific}_${mealTypeId}`;
      if (
        typeof row.sizes === 'undefined' ||
        row.sizes === null ||
        typeof row.sizes[key] === 'undefined' ||
        row.sizes[key] === null
      ) {
        return 0;
      }
      if (property === 'price') {
        return row.sizes[key][property];
      }
      return row.sizes[key].macrosAfterProcessing[property];
    })

    .reduce(add, 0)
    .toFixed(2);

// Netto liczone per danie (jak na karcie dania), żeby danie z błonnikiem > węglowodany
// nie zerowało netto całego dnia.
export const getTotalCarbohydratesNet = (calorific, menuPlanners) =>
  menuPlanners
    .map(row => {
      const mealTypeId = row.mealType.split('/').pop();
      const key = `${calorific}_${mealTypeId}`;
      if (
        typeof row.sizes === 'undefined' ||
        row.sizes === null ||
        typeof row.sizes[key] === 'undefined' ||
        row.sizes[key] === null
      ) {
        return 0;
      }
      const { carbohydrates, roughage } = row.sizes[key].macrosAfterProcessing;

      return Math.max(0, carbohydrates - roughage);
    })
    .reduce(add, 0)
    .toFixed(2);

export const getMacroInPercent = ({
  type,
  elementConstant,
  calorific,
  menuPlanners,
}) => {
  const macros = {
    calories: getTotalMenuPlanners('calories', calorific, menuPlanners),
    fat: getTotalMenuPlanners('fat', calorific, menuPlanners),
    protein: getTotalMenuPlanners('protein', calorific, menuPlanners),
    carbohydrates: getTotalMenuPlanners(
      'carbohydrates',
      calorific,
      menuPlanners
    ),
    sugar: getTotalMenuPlanners('sugar', calorific, menuPlanners),
    saturatedFattyAcids: getTotalMenuPlanners(
      'saturatedFattyAcids',
      calorific,
      menuPlanners
    ),
    salt: getTotalMenuPlanners('salt', calorific, menuPlanners),
  };

  const resultMacros =
    macros.fat * fatConstant +
    macros.protein * proteinConstant +
    macros.carbohydrates * carbohydratesConstant;

  const resultMacrosCalories = macros.calories
    ? resultMacros / macros.calories
    : 0;

  const resultPercent =
    resultMacros === 0 || resultMacrosCalories === 0
      ? 0
      : (
          ((macros[type] * elementConstant) / resultMacros) *
          100 *
          resultMacrosCalories
        ).toFixed(2);

  return resultPercent;
};

const utils = {
  getTotalMenuPlanners,
  getTotalCarbohydratesNet,
  getMacroInPercent,
  constant: {
    protein: proteinConstant,
    carbohydrates: carbohydratesConstant,
    fat: fatConstant,
    roughage: roughageConstant,
    sugar: sugarConstant,
    saturatedFattyAcids: saturatedFattyAcidsConstant,
    salt: saltConstant,
  },
};

export default utils;
